import React, { useMemo, useRef } from 'react';
// components
import HeaderNewUI from './new-ui';

// custom hooks
import { useUserInfo } from 'hooks/useUserInfo';
import { useAppSelector } from 'redux-store/hooks/useAppSelector';
// api
import { useGetMeQuery } from 'redux-store/api/auth';
import { useGetCompanyRolePermissionsMeQuery } from 'redux-store/api/company-roles';
import { useGetCompanyAllQuery, useGetCompanyQuery } from 'redux-store/api/company';
import { useSyncSelectedProject } from 'hooks/useSyncSelectedProject';
// selectors
import { authSelector } from 'redux-store/selector';
// redux
import { useGetCurrentPaymentPlanQuery } from 'redux-store/api/billing';

const Header: React.FC = () => {
  const anchorRef = useRef<HTMLButtonElement>(null);

  const { isAuth, companyId } = useAppSelector(authSelector);

  const { data: userMe } = useGetMeQuery(undefined, {
    skip: !isAuth,
  });
  const { data: userPermissions } = useGetCompanyRolePermissionsMeQuery(undefined, {
    skip: !userMe || !companyId,
  });
  const { data: companySetup } = useGetCompanyQuery(undefined, {
    skip: !userPermissions?.COMPANY_MANAGEMENT?.canRead,
  });
  const { currentRole } = useUserInfo();

  const pathname = window.location.pathname;

  const projectId = pathname.split('/')?.[2];

  const isProjectPage =
    Number(projectId) &&
    (pathname.includes('project-dashboard') ||
      (pathname.includes('selections') && !pathname.includes('selections-template')));

  // Sync project data to atom (for caching and state management)
  useSyncSelectedProject();

  const isShowBillingInfo = userPermissions?.BILLING?.canRead;

  const { data: currentPaymentPlan } = useGetCurrentPaymentPlanQuery();

  const { data: companyAllData } = useGetCompanyAllQuery();

  const companyData = useMemo(
    () =>
      companyAllData?.length
        ? companyAllData.filter((company) => {
            const role = userMe?.roles?.find((userRole) => company?.id === userRole?.companyId);

            return role?.isOwner || role?.isSubscription;
          })
        : [],
    [companyAllData, userMe]
  );

  const props = {
    isShowBillingInfo,
    currentRole,
    currentPaymentPlan,
    companyData,
    anchorRef,
    userMe,
  };

  return <HeaderNewUI {...props} />;
};

export default Header;
